/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte", "Diumenge"], a = ["Dl", "Dt", "Dc", "Dj", "Dv", "Ds", "Dg"], s = ["Gener", "Febrer", "Mar\xE7", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"], n = "Anys", r = "Any", D = "Mes", i = "Setmana", d = "Dia", o = "Avui", t = "No hi ha esdeveniments", m = "Tot el dia", y = "Eliminar", l = "Crear un esdeveniment", v = "dddd D MMMM YYYY", M = { weekDays: e, weekDaysShort: a, months: s, years: "Anys", year: "Any", month: "Mes", week: "Setmana", day: "Dia", today: "Avui", noEvent: t, allDay: "Tot el dia", deleteEvent: "Eliminar", createEvent: "Crear un esdeveniment", dateFormat: "dddd D MMMM YYYY" };
export {
  m as allDay,
  l as createEvent,
  v as dateFormat,
  d as day,
  M as default,
  y as deleteEvent,
  D as month,
  s as months,
  t as noEvent,
  o as today,
  i as week,
  e as weekDays,
  a as weekDaysShort,
  r as year,
  n as years
};
